/**
 * OrbDocCoreConceptsTraitsENDocEx3TimingView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsTraitsENDocEx3Timing
 */

import { useOrbDocCoreConceptsTraitsENDocEx3TimingLogic } from '@/hooks/traits/useOrbDocCoreConceptsTraitsENDocEx3TimingLogic';
import type { OrbDocCoreConceptsTraitsENDocEx3TimingConfig } from '@/hooks/traits/useOrbDocCoreConceptsTraitsENDocEx3TimingLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsTraitsENStopwatch } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsTraitsENDocEx3TimingViewProps {
  config?: Partial<OrbDocCoreConceptsTraitsENDocEx3TimingConfig>;
}

export function OrbDocCoreConceptsTraitsENDocEx3TimingView({ config: propsConfig }: OrbDocCoreConceptsTraitsENDocEx3TimingViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsTraitsENDocEx3TimingLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsTraitsENStopwatch'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsTraitsEN" trait="OrbDocCoreConceptsTraitsENDocEx3Timing">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="horizontal" gap="md" align="center"><Typography content={renderPatternValue([fields?.seconds, " s"].join(''))} variant="h2" /><Button label="Start" action="OrbDocCoreConceptsTraitsEN.OrbDocCoreConceptsTraitsENDocEx3Timing.START" variant="primary" /><Button label="Reset" action="OrbDocCoreConceptsTraitsEN.OrbDocCoreConceptsTraitsENDocEx3Timing.RESET" variant="ghost" /></Stack>) : slotWriter['main'] === 'START' ? (<Stack direction="horizontal" gap="md" align="center"><Typography content={renderPatternValue([fields?.seconds, " s"].join(''))} variant="h2" /><Button label="Stop" action="OrbDocCoreConceptsTraitsEN.OrbDocCoreConceptsTraitsENDocEx3Timing.STOP" variant="secondary" /></Stack>) : slotWriter['main'] === 'STOP' ? (<Stack direction="horizontal" gap="md" align="center"><Typography content={renderPatternValue([fields?.seconds, " s"].join(''))} variant="h2" /><Button label="Start" action="OrbDocCoreConceptsTraitsEN.OrbDocCoreConceptsTraitsENDocEx3Timing.START" variant="primary" /><Button label="Reset" action="OrbDocCoreConceptsTraitsEN.OrbDocCoreConceptsTraitsENDocEx3Timing.RESET" variant="ghost" /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsTraitsENDocEx3TimingView;
